import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useHistory } from 'react-router-dom';
import { FormInput, FormInputMask } from 'modules/common/input';
import Button from 'modules/common/input/Button';
import PropTypes from 'prop-types';
import { replaceAllString, storage } from 'modules/common/helper';
import { useSendCode } from '../hooks';
import * as c from '../constants';

const INIT_FORM = {
  mobile_number: '',
  email: '',
};

function SendCodeForm({ onSwitchForm, currentForm }) {
  const [isApiLoading, sendCode] = useSendCode();
  const history = useHistory();
  const schema = currentForm === 'mobile' ? c.schemaMobile : c.schemaEmail;

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: INIT_FORM,
    resolver: yupResolver(schema),
    reValidateMode: 'onSubmit',
  });

  const handleOnSubmit = (form) => {
    const regEx = /[()\s]/g;
    const args = {
      user:
        currentForm === 'mobile'
          ? replaceAllString(form?.mobile_number, regEx)
          : form?.email,
      type: currentForm,
    };
    sendCode(args, () => {
      storage.set('forgot-password-detail', args);
      history.push(`/forgot-password/verify/${currentForm}`);
    });
  };

  const handleOnFormChange = (value) => {
    onSwitchForm(value);
  };

  React.useEffect(() => {
    reset();
  }, [currentForm, reset]);

  return (
    <form onSubmit={handleSubmit(handleOnSubmit)}>
      <div>
        <div className="mt-2 mb-2 flex">
          {currentForm === 'mobile' ? (
            <button
              type="button"
              className="font-medium text-primary-500 text-sm ml-auto hover:text-primary-500"
              onClick={() => handleOnFormChange('email')}
            >
              User Email Address
            </button>
          ) : (
            <button
              type="button"
              className="font-medium text-primary-500 text-sm ml-auto hover:text-primary-500"
              onClick={() => handleOnFormChange('mobile')}
            >
              User Mobile No.
            </button>
          )}
        </div>
        <div className="border border-gray-200 rounded p-3 pb-1 mb-5">
          {currentForm === 'mobile' ? (
            <Controller
              control={control}
              name="mobile_number"
              render={(e) => (
                <FormInputMask
                  label="Mobile Number"
                  id="mobile_number"
                  placeholder="+63 (XXX) XXX XXXX"
                  mask="+63 \(\999\) 999 9999"
                  className="border-0 pr-12 pt-2 mt-1 ring-0 w-full outline-none text-gray-600"
                  error={errors?.mobile_number}
                  required
                  {...e.field}
                />
              )}
            />
          ) : (
            <Controller
              control={control}
              name="email"
              render={({ field: { onChange, value, name } }) => (
                <FormInput
                  name={name}
                  label="Email"
                  type="email"
                  error={errors[name]}
                  required
                  className="border-0 pr-12 pt-2 mt-1 ring-0 w-full outline-none text-gray-600"
                  placeholder="ex: juandelacruz@gmail.com"
                  withIcon={false}
                  value={value}
                  onChange={(e) => {
                    onChange(e);
                  }}
                />
              )}
            />
          )}
        </div>
      </div>
      <div className="space-y-3">
        <Button
          type="submit"
          isLoading={isApiLoading}
          className="btn primary md font-base text-sm"
          label="Next"
        />
      </div>
    </form>
  );
}
SendCodeForm.defaultProps = {};

SendCodeForm.propTypes = {
  onSwitchForm: PropTypes.instanceOf(Function).isRequired,
  currentForm: PropTypes.string.isRequired,
};

export default SendCodeForm;
